import { Outlet, useLocation } from 'react-router-dom'
import { VisualEditing } from '@sanity/visual-editing/react-router'
import { Footer } from '@autoplan/web-ui'
import TemporaryHeader from '../public/temporary-header.png'
import { useHomeContent, urlFor, useBrandSettings } from '@autoplan/web-sanity'

function Layout({ withoutSidebarPadding = false }: { withoutSidebarPadding?: boolean }) {
  const content = useHomeContent()
  const { logoUrl } = useBrandSettings()
  const { pathname } = useLocation()
  const isHome = pathname === '/'

  const headerSrc = content?.page?.headerImage
    ? (urlFor(content.page.headerImage)?.width(1600).height(350).url() ?? TemporaryHeader)
    : TemporaryHeader

  const sidebarPadding = withoutSidebarPadding ? '' : ' ap:md:pl-6xl'

  return (
    <div className="ap:relative ap:text-content-primary ap:w-full ap:h-dvh ap:flex ap:flex-col">
      <div className="ap:flex-1 ap:min-h-0 ap:overflow-y-auto">
        <div className="ap:relative ap:w-full">
          {isHome && (
            <div className="ap:absolute ap:w-full ap:h-87.5 ap:overflow-hidden ap:pointer-events-none ap:shrink-0 ap:-z-10">
              <img src={headerSrc} alt="" className="ap:w-full ap:h-full ap:object-cover ap:object-top" />
              <div className="ap:absolute ap:inset-0 ap:bg-linear-to-b ap:from-transparent ap:to-surface-background" />
            </div>
          )}
          <div className={`ap:flex ap:flex-col ap:w-full${sidebarPadding}`}>
            {isHome && logoUrl && (
              <div className="ap:mt-4 ap:flex ap:h-10 ap:items-center ap:justify-end ap:px-4 ap:md:mt-0 ap:md:h-auto ap:md:justify-start ap:md:px-2xl ap:md:pt-2xl">
                <img src={logoUrl} alt="Logo" className="ap:h-full ap:w-auto ap:object-contain ap:md:h-5xl" />
              </div>
            )}
            <div className={`ap:max-w-525 ap:px-2xl ap:pb-xl${isHome ? ' ap:mt-47.5' : ' ap:mt-20 ap:md:mt-10'}`}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <div className={`ap:shrink-0 ap:w-full${sidebarPadding}`}>
        <div className="ap:max-w-525 ap:px-2xl">
          <Footer />
        </div>
      </div>
      <VisualEditing />
    </div>
  )
}

export default Layout
